"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.button.login': '立即登录',
    'activate.button.back_login': '返回登录',
    'activate.button.register_again': '重新注册',
};
